module.exports = __webpack_public_path__ + "img/hefei@2x.0320a863.png";